export default __webpack_public_path__ + "static/media/covid.53cfdf15.jpg";